import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import M from "materialize-css";
import {  getUsersConnections } from "../../helpers/userConnectionFunc";
import { CircleGif } from "../CircleGif";
import { AuthContext } from "../../auth/authContext";
import { event } from "jquery";

//import { useGetEvidence } from '../../hooks/hooks_evidence';

export const UsersConnectionsHome = () => {
  const itemsPerPAge = 8;
  let count = 0;
  // let {pageNumber} = useParams();

  //Global info user dispatch
  const { currentUser } = useContext(AuthContext);

  const [listEvidence, setListevidence] = useState([]);
  // const [stateLatLng,setLatLng] = useState('');
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(1);
  const [serachText, setSerachText] = useState("");
  const [savePage, setSavePage] = useState({
    pagination: 1,
  });
  const { pagination } = savePage;
  let optionsDate = {
    weekday: "short",
    year: "numeric",
    month: "2-digit",
    day: "numeric"
  };

  //variables to DatesPICKERS
  function subtractDays(date, days) {
    date.setDate(date.getDate() - days);

    return date.toLocaleString('es-MX', optionsDate).split(',')[1];
  }

  const defaultDate = new Date(Date.now()).toLocaleString('es-MX', optionsDate).split(',')[1];
  console.info(Date(Date.now()).toLocaleString('es-MX', optionsDate));
  const backDays = subtractDays(new Date(Date.now()), 15)
  console.info(backDays)//new Date(Date.now().setDate()).toLocaleString().split(',')[0];
  let currenDate = defaultDate; //`${defaultDate.getDate()}/${defaultDate.getMonth()}/${defaultDate.getFullYear()}`;
  const [initDate, setInitDate] = useState(backDays);
  const [endDate, setEndDate] = useState(currenDate);

  //LOAD PAGE USEEFFECT
  useEffect(() => {
    let isMounted = true;
    let modalM = document.querySelectorAll(".modal");
    let pickerDate = document.getElementById("initDate");
    let endDatePick = document.getElementById("endDate");
    M.Modal.init(modalM);

    //START DATE
    M.Datepicker.init(pickerDate, {
      format: "dd/mm/yyyy",
      autoClose: true,
      selectMonths: true,
      // onClose: handleDate(),
      i18n: {
        months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        monthsShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Dic"],
        weekdays: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
        weekdaysShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
        weekdaysAbbrev: ["D", "L", "M", "M", "J", "V", "S"],
        cancel: 'Cancelar',
        clear: 'Limpar',
        done: 'Ok',

        previousMonth: '<',
        nextMonth: '>',
      },
      onSelect: function (date) {

        let finalDate = `${date.getDate()}/${date.getMonth()}/${date.getFullYear()}` //new Date(date).toLocaleString().split(',')[0];
        document.getElementById("initDate").value = date.toLocaleString().split(',')[0];
        // setInitDate(date.toLocaleString().split(',')[0]);
      },
      onOpen: function () {
        let instance = M.Datepicker.getInstance(document.getElementById("initDate"));
        let splitInitDate = document.getElementById("initDate").value.split('/');
        instance.setDate(new Date(parseInt(splitInitDate[2]), parseInt(splitInitDate[1]) - 1, parseInt(splitInitDate[0])));
      },
      onClose: function () {

        setInitDate(document.getElementById("initDate").value);
      }
    });
    //END DATE
    M.Datepicker.init(endDatePick, {
      format: "dd/mm/yyyy",
      autoClose: true,
      selectMonths: true,
      // onClose: handleDate(),
      i18n: {
        months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        monthsShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Dic"],
        weekdays: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
        weekdaysShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
        weekdaysAbbrev: ["D", "L", "M", "M", "J", "V", "S"],
        cancel: 'Cancelar',
        clear: 'Limpar',
        done: 'Ok',

        previousMonth: '<',
        nextMonth: '>',
      },
      onSelect: function (date) {

        let finalDate = `${date.getDate()}/${date.getMonth()}/${date.getFullYear()}` //new Date(date).toLocaleString().split(',')[0];

        document.getElementById("endDate").value = date.toLocaleString().split(',')[0];
        //setEndDate(date.toLocaleString().split(',')[0]);


      },
      onOpen: function () {
        let instance = M.Datepicker.getInstance(document.getElementById("endDate"));
        let splitInitDate = document.getElementById("endDate").value.split('/');
        instance.setDate(new Date(parseInt(splitInitDate[2]), parseInt(splitInitDate[1]) - 1, parseInt(splitInitDate[0])));
      },
      onClose: function () {

        setEndDate(document.getElementById("endDate").value);
      }
    });
    //reset pagination of Incidencias to 1
    localStorage.setItem(
      "savePageInc",
      JSON.stringify({
        pagination: 1,
      })
    );
    //save the pagination

    let pagination;

    if (!localStorage.getItem("savePage")) {
      const remeberPage = localStorage.getItem("savePage");
      if (remeberPage !== null) {
        const objRemebermeData = JSON.parse(remeberPage);
        console.log("Pagination => ", objRemebermeData["pagination"]);
        setPage(objRemebermeData["pagination"]);
      }
      setSavePage({
        pagination: page,
      });
      pagination = {
        pagination: page,
      };
      localStorage.setItem("savePage", JSON.stringify(pagination));
    } else {
      const remeberPage = localStorage.getItem("savePage");
      if (remeberPage !== null) {
        const objRemebermeData = JSON.parse(remeberPage);
        console.log("Pagination => ", objRemebermeData["pagination"]);
        setPage(objRemebermeData["pagination"]);
      }
      localStorage.removeItem("savePage");
      setSavePage({
        pagination: page,
      });
      pagination = {
        pagination: page,
      };
      localStorage.setItem("savePage", JSON.stringify(pagination));
    }
    // save and get pagination END

    return () => {
      isMounted = false;
    };

    //M.FormSelect(select);
  }, []);

  //list of evidences
  const [listEvidenceState, setListEvidences] = useState({
    listEvidenceData: [],
    loading: true,
  });

  useEffect(() => {
    let isMounted = true;

    setListEvidences({
      listEvidenceData: [],
      loading: true,
    });

    if (document.getElementById("endDate").value !== '') {

      let end = new Date(document.getElementById("endDate").value); //Date.parse(document.getElementById("endDate").value);
      let init = new Date(document.getElementById("initDate").value) //Date.parse(document.getElementById("initDate").value);

      if (end.getTime() < init.getTime()) {

        //show dialog
        Swal.fire({
          icon: "warning",
          title: "Aviso",
          text: "La Fecha final debe ser mayor a la fecha inicial.",
        });
        let endDateF = document.getElementById("endDate").value = "";
        setEndDate(endDateF);
        getUsersConnections(
          serachText,
          currentUser.idCompany,
          currentUser.id,
          currentUser.typeUser,
          document.getElementById('initDate').value,
          document.getElementById('endDate').value
        ).then((result) => {
          console.log("Evidencias=>", result);
          setListEvidences({
            listEvidenceData: result,
            loading: false,
          });
        });
      } else {
        getUsersConnections(
          serachText,
          currentUser.idCompany,
          currentUser.id,
          currentUser.typeUser,
          document.getElementById('initDate').value,
          document.getElementById('endDate').value
        ).then((result) => {
          console.log("Evidencias=>", result);
          setListEvidences({
            listEvidenceData: result,
            loading: false,
          });
        });
      }
    } else {
      getUsersConnections(
        serachText,
        currentUser.idCompany,
        currentUser.id,
        currentUser.typeUser,
        document.getElementById('initDate').value,
        document.getElementById('endDate').value
      ).then((result) => {
        console.log("Evidencias=>", result);
        setListEvidences({
          listEvidenceData: result,
          loading: false,
        });
      });
    }

    return () => {
      isMounted = false;
    };
  }, [page, endDate, initDate]);

  const { listEvidenceData, loading } = listEvidenceState;
  const getListEvidence = listEvidenceData;
  console.log(getUsersConnections);

  const onChangeSerachTextEvi = (e) => {
    //e.preventDefault();
    //const searchText = e.target.value;
    setSerachText(e.target.value);
  };

  const onKeyUpSerachTextEvi = (e) => {
    setSerachText(e.target.value);
    if (e.target.value == '') {
      searchEvidence({ preventDefault: () => {} });
    }
  };

  /**
   * GET List of evidences
   */
  const retriveEvidences = () => {
    const items = getListEvidence.slice(
      (page - 1) * itemsPerPAge,
      (page - 1) * itemsPerPAge + itemsPerPAge
    );
    setListevidence(items);
    setPageCount(Math.ceil(getListEvidence.length / itemsPerPAge));
  };
  /**
   * update list each click or page change
   */
  useEffect(() => {
    let isMounted = true;
    retriveEvidences();
    return () => {
      isMounted = false;
    };
  }, [page, itemsPerPAge, listEvidenceState]);

  //serachForm
  const searchEvidence = (event) => {
    event.preventDefault();

    setListEvidences({
      listEvidenceData: [],
      loading: true,
    });

    getUsersConnections(
      serachText,
      currentUser.idCompany,
      currentUser.id,
      currentUser.typeUser,
      document.getElementById('initDate').value,
      document.getElementById('endDate').value
    ).then((result) => {
      console.log("DATA AFTER SEARCH => ", result);
      setListEvidences({
        listEvidenceData: result,
        loading: false,
      });
    });

    if (listEvidenceState.listEvidenceData.length > 0) {
      retriveEvidences();
    }
  };

  const handlerBackArrowPage = () => {
    const arrowBack = document.getElementById("back");
    if (page === 1) {
      arrowBack.classList.add("disabled");
      setPage(1);
      localStorage.setItem(
        "savePage",
        JSON.stringify({
          pagination: 1,
        })
      );
    }
    if (page > 1) {
      arrowBack.classList.remove("disabled");
      const backPage = page - 1;
      setPage(backPage);
      setFormValues({ ...formValues, pageActive: backPage });
      localStorage.setItem(
        "savePage",
        JSON.stringify({
          pagination: backPage,
        })
      );
    }
  };

  const handlerNextArrowPage = () => {
    const netxArrow = document.getElementById("next");
    if (page === pageCount) {
      netxArrow.classList.add("disabled");
      //setPage(pageCount);
    }
    if (page < pageCount) {
      netxArrow.classList.remove("disabled");
      const nextPage = page + 1;
      setPage(nextPage);
      setFormValues({ ...formValues, pageActive: nextPage });
      localStorage.setItem(
        "savePage",
        JSON.stringify({
          pagination: nextPage,
        })
      );
    }
  };

  console.log("List evidence per page ===>", listEvidence);
  const jsonPagination = JSON.parse(localStorage.getItem("savePage"));
  const getPagination = jsonPagination["pagination"];
  const initialValues = { pageActive: getPagination };

  const [formValues, setFormValues] = useState(initialValues);

  const handleGoBackPage = (e) => {
    e.preventDefault();
    let numPag = document.getElementById("pageActive").value;
    console.log(numPag);
    setPage(parseInt(numPag));

    localStorage.setItem(
      "savePage",
      JSON.stringify({
        pagination: parseInt(numPag),
      })
    );
  };
  const onChangePageInput = (e) => {
    console.log(e.target.value);
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const newPagination = () => {
    return (
      <div className="row">
        <div className="contentPagination">
          <Link
            className={`${page === 1 ? "disabled" : ""}`}
            to=""
            id="back"
            onClick={handlerBackArrowPage}
          >
            <i className=" medium material-icons">chevron_left</i>
          </Link>
          {/* <div className="input-field  white lighten-5 inputRegisterUser spaceBottom20"> */}
          <form className="center" onSubmit={handleGoBackPage}>
            <div className="white inputPage">
              <input
                name="pageActive"
                type="number"
                className=""
                required
                id="pageActive"
                value={formValues.pageActive}
                onChange={onChangePageInput}
                min={1}
                max={pageCount}
                style={{ textAlign: "center" }}
              />
      
            </div>
          </form>
          <label className="deText center">de</label>
          <label className="deText center">{pageCount}</label>
          <Link
            className={`${page === pageCount ? "disabled" : ""}`}
            to=""
            id="next"
            onClick={handlerNextArrowPage}
          >
            <i className=" medium material-icons">chevron_right</i>
          </Link>
        </div>
      </div>
    );
  };

//renderTable Information
const listTableEvidence = () => {
  if (listEvidence.length > 0) {
   return (
    <div className="contentTable">
     <table className="striped highlight  responsive-table centered tableFont">
      <thead className="borderbotomLine">
       <tr>
        <th className="center">Compañía</th>
        <th className="center">Email</th>
        <th className="center">Fecha Registro</th>
       </tr>
      </thead>
      <tbody>
       {listEvidence.map((evidence) => {
        count++;
        // Formatear la fecha de registro
        const date = new Date(evidence.dateRegister);
        // AQUI AQUI AQUI
        // const formattedDate = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
        const formattedDate = evidence.dateRegister;

        const formato = new Intl.DateTimeFormat('es-MX', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false, // usa formato 24 horas
          timeZone: 'UTC'
        }).format(new Date(evidence.dateRegister));

        return (
         <tr
          id={count % 2 === 0 ? "rowHighLigth" : ""}
          key={`${evidence.id}-${count}`}
         >
          <td>{evidence.idCompany}</td>
          <td>{evidence.Email}</td>
          <td>{formato.toString().replace(",","")}</td>
         </tr>
        );
       })}
      </tbody>
     </table>
     {newPagination()}
    </div>
   );
  } else {
    return <div className="center">No se encontraron conexiones de usuarios.</div>;
  }
 };


  const handleChangeDates = (e) => {
    //e.preventDefault();
    console.log(e.target);
  }

  return (
    <div className="">
      <div className="containerEvid">
        <div className="" style={{ background: "#5E5E68" }}>
          <form
            className="center"
            style={{ padding: "10px 0px" }}
            onSubmit={searchEvidence}
          >
            <div className="input-field inputSerach ">
              <i
                className="material-icons  prefix "
                style={{ color: "#A3A3A9", left: "0px", top: "10px" }}
              >
                search
              </i>
              <input
                id="search"
                type="text"
                placeholder="Buscar"
                className="inputSerachBorderBottom"
                value={serachText}
                onChange={onChangeSerachTextEvi} 
                onKeyUp={onKeyUpSerachTextEvi}
              />
            </div>
          </form>
        </div>

        <div className="row center">
          <h4>CONEXIONES</h4>
        </div>

        {/** FILTER DATES */}
        <div className="row">
          <div className="col s12 m3 l3"></div>
          <div className="col s12 m3 l3"> <div className="input-field inputDate"><i className="material-icons prefix" style={{ color: "#A3A3A9", left: "0px", top: "10px" }} >today</i><i /><input className=" datepicker " type="text" id="initDate" value={initDate} onChange={handleChangeDates} /></div> </div>
          <div className="col s12 m3 l3"> <div className="input-field inputDate"><i className="material-icons prefix" style={{ color: "#A3A3A9", left: "0px", top: "10px" }} >today</i><i /><input className=" datepicker " type="text" id="endDate" value={endDate} placeholder={endDate === '' ? 'Fecha Final' : ''} onChange={handleChangeDates} /></div></div>
          <div className="col s12 m3 l3"></div>
        </div>
        {/** FILTER DATES */}

        {loading === true ? (
          <div className="row center">
            <CircleGif />
          </div>
        ) : (
          listTableEvidence()
        )}
      </div>
    </div>
  );
};
